// Create some re-useable definitions because
// many input types are identical in how
// we want to style them.

const textClassification = {
  label: "block mb-2 font-medium text--md",
  inner: ` 
      w-full
      flex
      items-center
      rounded-lg mb-1
      overflow-hidden
      outline outline-1
      outline-transparent
      formkit-invalid:outline-error
    `,
  input: "w-full h-12 px-4 text--sm placeholder-gray rounded-lg outline-none",
}

const boxClassification = {
  fieldset: "w-full",
  legend: "font-bold text-sm",
  wrapper: "flex mb-1 cursor-pointer",
  help: "mb-2",
  input: `
  cursor-pointer
      form-check-input appearance-none h-6 w-6 mr-2 border border-primary rounded-[3px] bg-transparent checked:bg-primary focus:outline-none focus:ring-0 transition duration-200 relative
      checked:after: content-[] after:absolute after:left-[8.4px] after:top-[2px] after:w-[6px] checked:after:h-[14px] checked:after:border checked:after:border-background checked:after:border-t-0 checked:after:border-r-2 checked:after:border-b-2 checked:after:border-l-0 checked:after:rotate-45
    `,
  label: "text-sm text-gray-700 mt-1 formkit-disabled:text-red-500",
}

const buttonClassification = {
  outer: "mb-0",
  wrapper: "mb-1",
  input:
    "w-full flex justify-center items-center bg-primary hover:bg-primary-hover active:bg-primary-pressed text-background text--btn py-[11px] px-[14px] disabled:opacity-50 disabled:pointer-events-none",
}

// export our definitions using our above
// templates and declare one-offs and
// overrides as needed.
export default {
  // the global key will apply to all inputs
  global: {
    outer: "mb-6 formkit-disabled:opacity-50",
    help: "text--xs  text-right",
    messages: "list-none p-0 mt-1 mb-0",
    message: "text-error mb-1 text--xs",
  },
  button: buttonClassification,
  color: {
    label: "block mb-1 font-bold text--sm",
    input: "w-16 h-8 appearance-none cursor-pointer border border-gray-300 rounded-md mb-2 p-1",
  },
  date: textClassification,
  "datetime-local": textClassification,
  checkbox: boxClassification,
  email: textClassification,
  file: {
    label: "block mb-1 text",
    inner: "max-w-md cursor-pointer",
    input:
      "text-gray-600 text--sm mb-1 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:bg-blue-500 file:text-white hover:file:bg-blue-600",
    noFiles: "block text-gray-800 text-sm mb-1",
    fileItem: "block flex text-gray-800 text-sm mb-1",
    fileRemove: "ml-auto text-blue-500 text-sm",
  },
  month: textClassification,
  number: textClassification,
  password: textClassification,
  radio: {
    ...boxClassification,
    outer: "mb-0",
    option: "pt-2",
    wrapper: "flex flex-row-reverse justify-between border-b border-gray-light",
    input: boxClassification.input.replace("rounded-sm", "rounded-full").replace("mr-2", "mr-0"),
    fieldset: "$reset",
    label: boxClassification.label.replace("text", "text--sm cursor-pointer"),
  },
  range: {
    inner: "max-w-md",
    input: "form-range appearance-none w-full h-2 p-0 bg-gray-200 rounded-full focus:outline-none focus:ring-0 focus:shadow-none",
  },
  search: textClassification,
  select: textClassification,
  submit: buttonClassification,
  tel: textClassification,
  text: textClassification,
  textarea: {
    ...textClassification,
    input: "block w-full h-32 p-4 border-none text--sm text-gray-700 placeholder-gray resize-none bg-background rounded-lg outline-none",
    inner: ` 
    w-full
      flex
      items-center
      rounded-lg mb-1
      overflow-hidden
      bg-background
      outline outline-1
      outline-transparent
      formkit-invalid:outline-error
    `,
  },
  time: textClassification,
  url: textClassification,
  week: textClassification,
}
